import React, { useState } from 'react';

const CONSENT_KEY = 'cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(CONSENT_KEY));

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
    // Reload so Clarity initializes with consent
    window.location.reload();
  };

  const handleReject = () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-lg">
      <div className="max-w-5xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <p className="text-sm text-slate-600 flex-1">
          Używamy plików cookie do analizy korzystania z aplikacji (Google Analytics, Microsoft Clarity, Meta Pixel).
          Niezbędne pliki cookie są zawsze aktywne. Niezależnie od wyboru, kluczowe zdarzenia biznesowe (np. rejestracja konta)
          mogą być przekazywane w formie zanonimizowanej do naszych partnerów reklamowych w celu pomiaru skuteczności kampanii.{' '}
          <a href="https://propertycheck.pro/privacy-policy/" target="_blank" rel="noopener noreferrer" className="underline text-violet-600 hover:text-violet-800">
            Polityka prywatności
          </a>
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <button
            onClick={handleReject}
            className="px-4 py-2 text-sm font-medium text-slate-600 border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors"
          >
            Odrzuć
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm font-medium text-white bg-violet-600 rounded-lg hover:bg-violet-700 transition-colors"
          >
            Akceptuj
          </button>
        </div>
      </div>
    </div>
  );
}
